import React, { Component } from 'react';
import { Route, Redirect, Switch, withRouter } from 'react-router-dom';
import $ from 'jquery';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import fbIcon from '../../images/socialIcons/FBicon.png';
import youtubeIcon from '../../images/socialIcons/youtubeicon.jpg';

import './SocialLoginForm.css';
// import {faFolderOpen} from '@fortawesome/fontawesome-free-solid';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { GoogleLogin } from 'react-google-login';
import { faFacebookF, faYoutube, faTwitter } from '@fortawesome/fontawesome-free-brands';
import toast from '../toast';

// import ShareSocialMedia from './SocialMedia/ShareSocialMedia/ShareSocialMedia';

class SocialLoginForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fbEmail: '',
      fbClientId: "231425867421205",
      fbName: '',
      fblogin: false,
      ytEmail: '',
      ytName: '',
      ytlogin: false,
      user: undefined,
      confirmModal: false,
      ytChannelId: '',
      instaLogin: false,
      twitterName: '',
      twitterUserName: '',
      twitterLogin: false,
      sendEmail: '',
      fbChild: []
    };

  }

  componentDidMount = () => {
    $.ajax({
      method: 'GET',
      url: '/api/v1/invite/media?userId=' + window.location.pathname.split('/')[4] + '&token=' + window.location.pathname.split('/')[5],
      success: function (success) {
        if (success.response.length) {
          success.response.forEach((loginMedia) => {
            if (loginMedia.type == 'FACEBOOK') {
              this.setState({
                fbName: loginMedia.name,
                fbEmail: loginMedia.email,
                fblogin: true
              });
            }
            if (loginMedia.type == 'YOUTUBE') {
              this.setState({
                ytEmail: loginMedia.email,
                ytName: loginMedia.name,
                ytlogin: true
              });
            }
          })
        }
      }.bind(this),
      error: function (err) {
        console.log(err);
      }.bind(this)
    });
  }

  notifySuccess = (msg) => {
    toast.success(msg);
  }

  notifyError = (msg) => {
    toast.error(msg);
  }


  responseFacebook = (response) => {
    if (!response.id) {
      return;
    }
    $.ajax({
      method: 'GET',
      url: 'https://graph.facebook.com/v20.0/me?fields=accounts&access_token=' + response.accessToken,
      success: (success) => {
        let fbPages = [];
        if (success.accounts) {
          fbPages = success.accounts.data.map((pages) => {
            if (pages.access_token)
              return {
                access_token: pages.access_token,
                id: pages.id,
                name: pages.name
              }
          })
        }
        this.addFacebookDetail(response, fbPages);
      },
      error: (err) => {
        console.log(err)
      }
    })
  }

  addFacebookDetail = (fbTimeLine, fbPages) => {
    let data = this.fbBodyData(fbTimeLine, fbPages);
    data.fbPages.push({
      name: fbTimeLine.name,
      id: fbTimeLine.id,
      access_token: fbTimeLine.accessToken,
      type: 'Timeline'
    })
    data.access_token = fbTimeLine.accessToken;
    data.timelineId = fbTimeLine.id;
    data.userId = window.location.pathname.split('/')[4];
    data.invitationToken = window.location.pathname.split('/')[5];
    $.ajax({
      method: 'POST',
      url: '/api/v1/invite/media',
      data: JSON.stringify({
        data: data
      }),
      success: (success) => {
        if (success) {
          this.componentDidMount();
        }
      },
      error: (err) => {
        console.error(err);
      }
    })
  }

  fbBodyData = (fbTimeLine, fbPages) => {
    return {
      email: fbTimeLine.email,
      name: fbTimeLine.name,
      type: 'FACEBOOK',
      fbPages: fbPages
    }
  }



  handleGoogleLogin = (user) => {
    this.setState({
      user: user.code
    });
    this.addYoutube();
  }

  addYoutube = () => {
    $.ajax({
      method: 'POST',
      url: '/api/v1/invite/media',
      data: JSON.stringify({
        type: 'YOUTUBE',
        code: this.state.user,
        userId: window.location.pathname.split('/')[4],
        invitationToken: window.location.pathname.split('/')[5],
        isChild: true
      }),
      success: (success) => {
        this.updateYoutubeLogin(success.response);
      },
      error: (err) => {
      }
    });
  }
  updateYoutubeLogin = (response) => {
    this.setState({
      ytEmail: response.email,
      ytName: response.name,
      ytlogin: true
    });
  }

  removeSocialMedia = (type) => {
    let self = this;
    $.ajax({
      method: 'DELETE',
      url: '/api/v1/invite/media?userId=' + window.location.pathname.split('/')[4] + '&token=' + window.location.pathname.split('/')[5] + '&type=' + type,
      success: function (success) {
        if (type == 'YOUTUBE')
          this.setState({
            ytEmail: '',
            ytName: '',
            ytlogin: false
          });
        else
          this.setState({
            fbName: '',
            fbEmail: '',
            fblogin: false
          });
      }.bind(this),
      error: function (err) {
        // this.notifyError(err.responseJSON.message);
      }.bind(this)
    })
  }




  render() {
    const currentLocationPath = this.props.location.pathname;
    const { t } = this.props;

    return (
      <div className="SocialLogin__Main__Listing d-flex flex-column flex-grow">
        <ul className="social-login-list p-0 px-4 media-center">
          <li className="social-login-list__item d-flex align-items-center p-2 mb-3">
            <span className="social-login__icon">
              <img src={fbIcon} alt="facebook icon" />
            </span>
            {/* social media's name */}
            <span className="social-login__name mx-2"><h2>Facebook</h2></span>
            {/* account details */}
            <span className="social-login__account flex-grow text-center mx-2">
              <h2 className="social-login__account__ID m-0">{this.state.fbName}</h2>
              <p className="social-login__account__email m-0">{this.state.fbEmail}</p>
            </span>
            {/* login/logout button */}
            <span className="social-login__button ml-2">
              {!this.state.fblogin ? (
                <FacebookLogin
                  appId={this.state.fbClientId}
                  fields="email,name"
                  scope="user_videos, email, publish_video, public_profile, pages_read_engagement, pages_read_user_content, pages_manage_posts, pages_manage_engagement"
                  version="7.0"
                  callback={this.responseFacebook}
                  render={renderProps => (
                    <button className="btn add-account-btn" type="button" onClick={renderProps.onClick}> Login </button>
                  )} />
              )
                : (<button type="button" onClick={() => { this.removeSocialMedia('FACEBOOK') }} className="btn add-account-btn">
                  Logout </button>)
              }
            </span>
          </li>
          <li className="social-login-list__item d-flex align-items-center p-2 mb-3">
            <span className="social-login__icon">
              <img src={youtubeIcon} alt="youtube icon" />
            </span>
            <span className="social-login__name mx-2">
              <h2>Youtube</h2>
            </span>
            <span className="social-login__account flex-grow text-center mx-2">
              <h2 className="social-login__account__ID m-0">{this.state.ytName}</h2>
              <p className="social-login__account__email m-0">{this.state.ytEmail}</p>
            </span>
            <span className="social-login__button ml-2">
              {
                !this.state.ytlogin ? (<div>
                  <GoogleLogin
                    apiKey="AIzaSyDB9Yr7gO_k4ZNub-5fCiPYafIAKO2-oqc"
                    clientId="242384257630-cutoeuml04eq6e80t2rpg83leu0vpm97.apps.googleusercontent.com"
                    client_secret="fsbPEjKRlM0JnklcTfj5Sjav"
                    scope="https://www.googleapis.com/auth/youtube.force-ssl https://www.googleapis.com/auth/youtube https://www.googleapis.com/auth/youtube.readonly https://www.googleapis.com/auth/yt-analytics.readonly"
                    discoveryDocs='https://www.googleapis.com/discovery/v1/apis/youtube/v3/rest'
                    prompt='consent'
                    access_type='offline'
                    responseType='code'
                    render={renderProps => (
                      <button type="button" className="btn add-account-btn" onClick={renderProps.onClick} disabled={this.state.youtubeChannelLimitExceed ? true : false}> Login </button>
                    )}
                    onSuccess={this.handleGoogleLogin}
                    cookiePolicy={'single_host_origin'}
                  />
                </div>)
                  :
                  (<div>
                    <button onClick={() => this.removeSocialMedia('YOUTUBE')} className="btn add-account-btn">
                      Logout
                    </button>
                  </div>)
              }
            </span>
          </li>
        </ul>

      </div>

    );

    // if(socialUrl){
    //   return(<Route path="/social/media/login" render={(props) => (
    //     <ShareSocialMedia {...props}
    //     notifySuccess={this.notifySuccess}
    //     notifyError={this.notifyError} />
    // )} />)
    // }
    // else {
    //   return <Redirect to={'/'} />;
    // }
  }
}

export default withRouter(SocialLoginForm);



// WEBPACK FOOTER //
// ./src/components/SocialMediaPage/SocialLoginForm.js